import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import { ALLOW_LIST_TYPE, ALLOW_LIST_PURPOSE } from 'src/features/parkingManagement/types/allowList';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { AllowList } from 'src/features/parkingManagement/types/allowList';

export type MutationFnType = typeof mutationFn;

const RESOURCE = '/parkings/:parkingId/allow-list/';

export type AllowListFormSchemaValues = z.infer<typeof allowListFormSchema>;
export const allowListFormSchema = z.object({
    name: z.string().min(1),
    type: z.nativeEnum(ALLOW_LIST_TYPE),
    purposes: z.array(z.nativeEnum(ALLOW_LIST_PURPOSE)),
});

export interface DTO extends AllowListFormSchemaValues {
    parkingId: string;
}

const mutationFn = ({ parkingId, ...data }: DTO): Promise<AllowList> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

interface UseCreateAdditionalServicesOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}

export const useMutationHook = (options: UseCreateAdditionalServicesOptions) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateAllowList };
